<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="visible"
    width="480px"
    :close-on-click-modal="false"
    :append-to-body="true"
    @close="visible = false"
  >
    <el-form :model="form" :rules="rules" ref="form" label-width="80px">
      <el-form-item label="分类名称" prop="name">
        <el-input v-model.trim="form.name" maxlength="20" show-word-limit placeholder="请输入分类名称"></el-input>
      </el-form-item>
      <el-form-item label="分类描述">
        <el-input v-model.trim="form.description" maxlength="100" show-word-limit type="textarea" :rows="2" placeholder="请输入分类描述（选填）"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addAttributeCategory, updateAttributeCategory } from '@/api/attributeDict.js';

export default {
  name: 'EditCategoryDialog',
  data () {
    return {
      visible: false,
      submitting: false,
      dialogTitle: '新增分类',
      form: {
        id: null,
        name: '',
        description: '',
        parentId: null,
        parentIsPlatformFlag: false,
      },
      rules: {
        name: [{ required: true, message: '请输入分类名称', trigger: ['blur', 'change'] }],
      },
    };
  },
  methods: {
    open ({ id = null, name = '', description = '', parentId = null, parentIsPlatformFlag = false, title = '新增分类' }) {
      this.form = { id, name, description, parentId, parentIsPlatformFlag };
      this.dialogTitle = title;
      this.visible = true;
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
    },
    handleSubmit () {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.submitting = true;
        const api = this.form.id ? updateAttributeCategory : addAttributeCategory;
        api({ ...this.form }).then(res => {
          if (res.heads.code === 200) {
            this.$message.success(this.form.id ? '更新成功' : '新增成功');
            this.visible = false;
            this.$emit('success');
          }
        }).finally(() => { this.submitting = false; });
      });
    },
  },
};
</script>
